





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import OtSelect, { ISelectItem } from '@/components/global/ot-select.vue';
import { OtDataDrivenQuestion } from '../models/data-driven-question';
import { OtDataDrivenResponse, IResponsesGroupedByLayoutKey } from '../models/data-driven-response';
import { IWorkflowComponentEditDefinition } from '../models/workflow-component-definition';
import { OtDataDrivenOptionValue } from '../models/data-driven-result';
import { OtDataDrivenDefinition } from '../models/data-driven-definition';
import { OtDataDrivenInstance } from '../models/data-driven-instance';

@Component({
  components: {
    OtSelect,
  },
})
export default class WfDropdownSelectEdit extends Vue implements IWorkflowComponentEditDefinition {
  // * PROPS
  @Prop() public question!: OtDataDrivenQuestion;
  @Prop() public value!: OtDataDrivenResponse | null;
  @Prop() public readonly definition!: OtDataDrivenDefinition;
  @Prop() public readonly instance!: OtDataDrivenInstance;
  @Prop({ default: () => [] }) public readonly defaultValues!: IResponsesGroupedByLayoutKey[];
  @Prop({ default: false }) public readonly!: boolean;
  @Prop({ default: false }) public disabled!: boolean;

  // * REFS

  // * DATA
  private title: string | null = null;
  private description: string | null = null;
  private placeholder: string | null = null;
  private requiredMessage: string | null = null;

  // * COMPUTED
  private get items(): ISelectItem<string>[] {
    return (
      this.question.optionsOrdered.map(o => {
        return { label: o.title, data: o.key };
      }) || []
    );
  }

  private selectedValuePrivate: ISelectItem<string> | null = null;
  private get selectedValue(): ISelectItem<string> | null {
    return this.selectedValuePrivate;
  }
  private set selectedValue(val: ISelectItem<string> | null) {
    this.selectedValuePrivate = val;
    this.onChange();
  }

  private get result() {
    if (this.value) {
      if (this.value.result.resultType === 'OptionsValueModel') {
        return this.value.result;
      }
      console.warn(
        'wf-dropdown-select-edit -> result -> ResultType is incorrect. Expected OptionsValueModel but got:  ',
        this.value.result.resultType,
      );
    }
    return null;
  }

  // * WATCHERS
  @Watch('value')
  private valueChanged() {
    this.selectedValuePrivate = this.items.find(i => i.data === this.result?.key) || null;
  }

  // * METHODS
  public onChange() {
    const result = new OtDataDrivenOptionValue({
      resultType: 'OptionsValueModel',
      key: this.selectedValue?.data || '',
    });

    const val = new OtDataDrivenResponse({
      questionKey: this.question.key,
      result: result,
      systemControlled: this.value?.systemControlled ?? false,
    });
    this.$emit('input', val);
  }

  // * LIFECYCLE
  private created() {
    this.title = this.question.title;
    this.description = this.question.description;
    this.placeholder = this.question.placeholder;
    this.requiredMessage = this.question.isMandatory ? 'This field is mandatory' : null;

    this.valueChanged();
  }
}
